module.exports = __webpack_public_path__ + "img/right-banner01-m.604375ac.png";